import React from 'react';
import { TextField } from '@mui/material';
import { useSave } from '../graphql/hooks';

interface InlineInputProps {
  value: any;
  table: string;
  field: string;
  id: number;
  refresh: string;
}

const InlineInput = ({
  value,
  table,
  field,
  id,
  refresh,
}: InlineInputProps) => {
  const [val, setVal] = React.useState(value);
  const save = useSave(table, refresh);

  return (
    <TextField
      value={val || ''}
      onChange={(e: any) => {
        setVal(e.target.value);
      }}
      onBlur={() => {
        if (val !== value) {
          save({
            id,
            [field]: val,
          });
        }
      }}
      label={val === value ? '' : 'Changes made'}
    />
  );
};

export default InlineInput;
